/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSuccessStoryDto } from '../../models/create-success-story-dto';
import { SuccessStoryResponseAdminDto } from '../../models/success-story-response-admin-dto';

export interface AdminSuccessStoriesControllerCreateSuccessStoryV1$Params {
      body: CreateSuccessStoryDto
}

export function adminSuccessStoriesControllerCreateSuccessStoryV1(http: HttpClient, rootUrl: string, params: AdminSuccessStoriesControllerCreateSuccessStoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessStoryResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminSuccessStoriesControllerCreateSuccessStoryV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessStoryResponseAdminDto>;
    })
  );
}

adminSuccessStoriesControllerCreateSuccessStoryV1.PATH = '/v1/admin/success-stories';
